<template>
   <div>
      <vue-headful
         title="Home"
         description="Mathew Moose - Software Engineer. This is a portfolio site used to showcase some of my work."
         />
        <div class="intro">
            <h1 class="name">Mathew</h1>
            <h1 class="name">Moose</h1>
            <h2 class="title">Programmer / Math Whiz / Nerd</h2>
        </div>
        <div class="logo-container">
          <!-- Modular MM with Outline (Cleaned) -->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108.76465 114.55157" class="logo">
          <path id="M2" fill="#2b9bff" stroke="#000" stroke-width=".75" d="M2.415585 32.83757a11.7 11.7 0 0 0-1.3321044 10.622814L24.01251 106.45737a11.7 11.7 0 0 0 15.031035 7.00103l2.386728-.8687a11.7 11.7 0 0 0 7.671198-10.02587 11.7 11.7 0 0 1-5.67329 4.40376l-2.377501.86534a11.7 11.7 0 0 1-15.043797-7.00738L3.0778533 37.828562a11.7 11.7 0 0 1-.6622683-4.990992zm68.148319 12.289399l-1.610238 4.523579-.583138 1.644813.189778-.533212 12.688998 34.862736a11.7 11.7 0 0 0 15.031036 7.001022l2.386728-.868698a11.7 11.7 0 0 0 7.661312-10.010726 11.7 11.7 0 0 1-5.66389 4.388795l-2.377016.865163a11.7 11.7 0 0 1-15.034571-7.010736zM37.910268 57.512356l3.103982 8.528121 18.41101 10.468869 1.998787-5.637828-19.676786-11.180066z"/>
          <path id="M1" fill="#6cffb3" stroke="#000" stroke-width=".75" d="M10.097522 22.790916a11.7 11.7 0 0 0-7.020092 15.03791l22.929031 62.996994a11.7 11.7 0 0 0 15.043884 7.00728l2.377423-.86531a11.7 11.7 0 0 0 7.010698-15.034493L37.910268 57.512356l3.836709 2.17919 19.681718 11.182865 7.524905-21.22361 1.609985-4.523444 12.688947 34.862597a11.7 11.7 0 0 0 15.0345 7.010694l2.377408-.865307a11.7 11.7 0 0 0 7.0107-15.034491L84.746113 8.1038574a11.7 11.7 0 0 0-15.034491-7.0106983l-2.377413.8653075c-3.75878 1.368084-6.389298 4.4325863-7.332308 8.0109143L54.972055 23.633752 49.55721 38.374727l-.04698.0171-13.623318-7.81165-12.691073-7.267694a11.7 11.7 0 0 0-10.720895-1.386877z"/>
        </svg>

        </div>
   </div>
</template>

<script>
export default {

  name: 'Home',
  data: function () {
    return {
      msg: 'Welcome to MooseCreates'
    }
  }
}
</script>

<style scoped>
@media only screen and (max-width: 600px) {
    /* .intro{
      position: relative !important;
    } */
    .name{
      font-size: 3.75rem;
      line-height: 3.5rem;
    }
    .title{
      font-size: 1.25rem;
    }
    .logo-container{
      width: 80vw;
      /* position: relative !important; */
    }
}
@media only screen and (min-width: 601px) {
    .name{
      font-size: 4.25rem;
      line-height: 3.5rem;
    }
    .title{
      font-size: 2rem;
    }
    .logo-container{
      width: 60vw;
    }
}
@media only screen and (min-width: 769px) {
    .intro{
      left: 5%;
    }
    .logo-container{
      width: 60vw;
    }
}
@media only screen and (min-width: 1101px) {
    .intro{
      left: 10%;
    }
    .logo-container{
      width: 35vw;
    }
}
@media only screen and (min-width: 1401px) {
    .intro{
      left: 10%;
    }
    .logo-container{
      width: 35vw;
    }
}
.text{
  animation: rubberBand 1.25s linear 0s forwards;
}
.intro{
  text-align: left;
  position: absolute;
  color: white;
  z-index: 1;
  text-shadow: 1px 1px 0px black; /* FF3.5+, Opera 9+, Saf1+, Chrome, IE10 */
  top: 35%;
  padding: 0px 1.25rem;
}
.name{
   font-family: 'Russo One', sans-serif;
}
.title{
  font-family: 'Orbitron', sans-serif;
}
.logo-container{
  right: 7%;
  top: 15%;
  position: absolute;
  overflow: hidden;
}
.logo{
  position: relative;
  width: 100%;
  z-index: 0;
}
.list-item {
  display: inline-block;
  padding: 0px 3px;
}
.list-enter-active, .list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-50px);
}

.title, .subtitle{
  color: white;
}
#M1, #M2{
  fill: transparent;
}
#M1{
  stroke-dasharray: 466px;
  stroke-dashoffset: 466px;
  -webkit-animation: M1-Draw 1.25s linear 0s forwards, M1-Color 1.5s ease-in 1.25s forwards;
  -moz-animation: M1-Draw 1.25s linear 0s forwards, M1-Color 1.5s ease-in 1.25s forwards;
  -o-animation: M1-Draw 1.25s linear 0s forwards, M1-Color 1.5s ease-in 1.25s forwards;
  animation: M1-Draw 1.25s linear 0s forwards, M1-Color 1.5s ease-in 1.25s forwards;
}
#M2{
  stroke-dasharray: 215px;
  stroke-dashoffset: 215px;
  -webkit-animation: M2-Draw 0.5s linear 1.25s forwards, M2-Color 1s ease-in 1.75s forwards;
  -moz-animation: M2-Draw 0.5s linear 1.25s forwards, M2-Color 1s ease-in 1.75s forwards;
  -o-animation: M2-Draw 0.5s linear 1.25s forwards, M2-Color 1s ease-in 1.75s forwards;
  animation: M2-Draw 0.5s linear 1.25s forwards, M2-Color 1s ease-in 1.75s forwards;
}
@keyframes M1-Draw{
  from {stroke-dashoffset:466px}
  to {stroke-dashoffset: 0px;}
}
@keyframes M2-Draw{
  from {stroke-dashoffset:215px}
  to {stroke-dashoffset: 0px;}
}
@keyframes M1-Color{
  from {fill: transparent}
  to {fill: #6cffb3ff}
}
@keyframes M2-Color{
  from {fill: transparent}
  to {fill: #2b9bffff}
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue